module.exports = __webpack_public_path__ + "assets/advantages-navigate-5de239.svg";